@if (form) {
    <form
        class="pt-10"
        [formGroup]="form">
        <mat-form-field class="w-full px-6">
            <mat-label>Name</mat-label>
            <input
                matInput
                formControlName="name" />
        </mat-form-field>
        <mat-accordion multi>
            <mat-expansion-panel
                [formGroup]="form.controls.deviceModels"
                expanded>
                <mat-expansion-panel-header>
                    <mat-panel-title>Device models</mat-panel-title>
                </mat-expansion-panel-header>
                <ng-template matExpansionPanelContent>
                    <div class="flex flex-col gap-y-2">
                        <mat-checkbox
                            color="primary"
                            formControlName="include"
                            (change)="resetForm($event, form.controls.deviceModels)">
                            Include parameter
                        </mat-checkbox>
                        <mat-checkbox
                            color="primary"
                            formControlName="isMandatory">
                            Mandatory
                        </mat-checkbox>
                        <mat-form-field class="pl-2">
                            <mat-label>Device models</mat-label>
                            <mat-chip-grid
                                #chipGrid
                                formControlName="value">
                                @for (tag of form.controls.deviceModels.value.value; track tag) {
                                    <mat-chip-row
                                        (removed)="
                                            removeChip($event.chip.value, 'deviceModels.value')
                                        ">
                                        {{ tag }}
                                        <button matChipRemove>
                                            <mat-icon>cancel</mat-icon>
                                        </button>
                                    </mat-chip-row>
                                }
                            </mat-chip-grid>
                            <input
                                [matChipInputFor]="chipGrid"
                                (matChipInputTokenEnd)="addChip($event, 'deviceModels.value')" />
                        </mat-form-field>
                    </div>
                </ng-template>
            </mat-expansion-panel>
            <mat-expansion-panel
                [formGroup]="form.controls.operationSystemVersions"
                expanded>
                <mat-expansion-panel-header>
                    <mat-panel-title>Operation system versions</mat-panel-title>
                </mat-expansion-panel-header>
                <ng-template matExpansionPanelContent>
                    <div class="flex flex-col gap-y-2">
                        <mat-checkbox
                            color="primary"
                            formControlName="include"
                            (change)="resetForm($event, form.controls.operationSystemVersions)">
                            Include parameter
                        </mat-checkbox>
                        <mat-checkbox
                            color="primary"
                            formControlName="isMandatory">
                            Mandatory
                        </mat-checkbox>
                        <mat-form-field class="pl-2">
                            <mat-label>Operation system versions</mat-label>
                            <mat-chip-grid
                                #chipGrid
                                formControlName="value">
                                @for (
                                    tag of form.controls.operationSystemVersions.value.value;
                                    track tag
                                ) {
                                    <mat-chip-row
                                        (removed)="
                                            removeChip(
                                                $event.chip.value,
                                                'operationSystemVersions.value'
                                            )
                                        ">
                                        {{ tag }}
                                        <button matChipRemove>
                                            <mat-icon>cancel</mat-icon>
                                        </button>
                                    </mat-chip-row>
                                }
                            </mat-chip-grid>
                            <input
                                [matChipInputFor]="chipGrid"
                                (matChipInputTokenEnd)="
                                    addChip($event, 'operationSystemVersions.value')
                                " />
                        </mat-form-field>
                    </div>
                </ng-template>
            </mat-expansion-panel>
            <mat-expansion-panel
                [formGroup]="form.controls.sex"
                expanded>
                <mat-expansion-panel-header>
                    <mat-panel-title>Sex</mat-panel-title>
                </mat-expansion-panel-header>
                <ng-template matExpansionPanelContent>
                    <div class="flex flex-col gap-y-2">
                        <mat-checkbox
                            color="primary"
                            formControlName="include"
                            (change)="resetForm($event, form.controls.sex)">
                            Include parameter
                        </mat-checkbox>
                        <mat-checkbox
                            color="primary"
                            formControlName="isMandatory">
                            Mandatory
                        </mat-checkbox>
                        <mat-form-field class="pl-2">
                            <mat-label>Value</mat-label>
                            <mat-select
                                formControlName="value"
                                multiple>
                                @for (keyValue of Sex | appEnumKeyValue; track $index) {
                                    <mat-option [value]="keyValue.value">
                                        {{ keyValue.key }}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                </ng-template>
            </mat-expansion-panel>
            <mat-expansion-panel
                [formGroup]="form.controls.isMobile"
                expanded="">
                <mat-expansion-panel-header>
                    <mat-panel-title>Mobile</mat-panel-title>
                </mat-expansion-panel-header>
                <ng-template matExpansionPanelContent>
                    <div class="flex flex-col">
                        <mat-checkbox
                            color="primary"
                            formControlName="include"
                            (change)="resetForm($event, form.controls.isMobile)">
                            Include parameter
                        </mat-checkbox>
                        <mat-checkbox
                            color="primary"
                            formControlName="isMandatory">
                            Mandatory
                        </mat-checkbox>
                        <mat-checkbox
                            color="primary"
                            formControlName="value">
                            Value
                        </mat-checkbox>
                    </div>
                </ng-template>
            </mat-expansion-panel>
            <mat-expansion-panel
                [formGroup]="form.controls.isPayer"
                expanded="">
                <mat-expansion-panel-header>
                    <mat-panel-title>Payer</mat-panel-title>
                </mat-expansion-panel-header>
                <ng-template matExpansionPanelContent>
                    <div class="flex flex-col">
                        <mat-checkbox
                            color="primary"
                            formControlName="include"
                            (change)="resetForm($event, form.controls.isPayer)">
                            Include parameter
                        </mat-checkbox>
                        <mat-checkbox
                            color="primary"
                            formControlName="isMandatory">
                            Mandatory
                        </mat-checkbox>
                        <mat-checkbox
                            color="primary"
                            formControlName="value">
                            Value
                        </mat-checkbox>
                    </div>
                </ng-template>
            </mat-expansion-panel>
            <mat-expansion-panel
                [formGroup]="form.controls.gameCategoryIds"
                expanded>
                <mat-expansion-panel-header>
                    <mat-panel-title>Game categories</mat-panel-title>
                </mat-expansion-panel-header>
                <ng-template matExpansionPanelContent>
                    <div class="flex flex-col gap-y-2">
                        <mat-checkbox
                            color="primary"
                            formControlName="include"
                            (change)="resetForm($event, form.controls.gameCategoryIds)">
                            Include parameter
                        </mat-checkbox>
                        <mat-checkbox
                            color="primary"
                            formControlName="isMandatory">
                            Mandatory
                        </mat-checkbox>
                        <mat-form-field class="pl-2">
                            <mat-label>Value</mat-label>
                            <mat-select
                                formControlName="value"
                                multiple>
                                @for (category of gameCategoriesStore.entities(); track $index) {
                                    <mat-option [value]="category.id">
                                        {{ category.name }}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                </ng-template>
            </mat-expansion-panel>
            @for (item of limitedForms(); track $index) {
                <mat-expansion-panel
                    [formGroup]="item.form"
                    expanded>
                    <mat-expansion-panel-header>
                        <mat-panel-title>{{ item.name }}</mat-panel-title>
                    </mat-expansion-panel-header>
                    <ng-template matExpansionPanelContent>
                        <div class="flex gap-x-4">
                            <mat-checkbox
                                color="primary"
                                formControlName="include"
                                (change)="resetForm($event, item.form)">
                                Include parameter
                            </mat-checkbox>
                            <mat-checkbox
                                color="primary"
                                formControlName="isMandatory">
                                Mandatory
                            </mat-checkbox>
                            <div
                                [formGroup]="item.form.controls.value"
                                class="flex gap-x-4">
                                <mat-form-field>
                                    <mat-label>Min</mat-label>
                                    <input
                                        matInput
                                        formControlName="min" />
                                </mat-form-field>
                                <mat-form-field>
                                    <mat-label>Max</mat-label>
                                    <input
                                        matInput
                                        formControlName="max" />
                                </mat-form-field>
                            </div>
                        </div>
                    </ng-template>
                </mat-expansion-panel>
            }
        </mat-accordion>
        <button
            class="ml-5 mt-5"
            mat-flat-button
            color="primary"
            (click)="save()">
            Save
        </button>
    </form>
}
